import { archiveUploadsBySourceIdForCategory } from 'app/utils/uploadFile';
import { db } from "app/firebaseInit";
import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    writeBatch,
    getDoc,
    query,
    where,
    setDoc,
    serverTimestamp
} from 'firebase/firestore';

const CATEGORY_COLLECTION = 'categories';
const CONTENT_COLLECTION = 'contents';

// Firestore'dan kategori listesini çek ve cache'e kaydet
export const fetchCategoriesFromFirestore = async () => {
    try {
        console.log("Fetching categories from Firestore...");
        const snapshot = await getDocs(collection(db, CATEGORY_COLLECTION));
        const categoriesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Kategorileri localStorage'e kaydet
        // localStorage.setItem('categories', JSON.stringify(categoriesData));

        return categoriesData;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw new Error("Kategoriler alınırken hata oluştu.");
    }
};

// Yeni kategori ekle
export const addCategoryToFirestore = async (categoryData) => {
    try {
        const docRef = await addDoc(collection(db, CATEGORY_COLLECTION), categoryData);
        return docRef;
    } catch (error) {
        console.error("Error adding category:", error);
        throw new Error("Kategori eklenirken hata oluştu.");
    }
};

// Kategori güncelle
export const updateCategoryInFirestore = async (id, updatedData) => {
    try {
        const ref = doc(db, CATEGORY_COLLECTION, id);
        await updateDoc(ref, updatedData);
    } catch (error) {
        console.error("Error updating category:", error);
        throw new Error("Kategori güncellenirken hata oluştu.");
    }
};

// Kategori sil
export const deleteCategoryFromFirestore = async (categoryToDelete) => {
    try {
        const ref = doc(db, CATEGORY_COLLECTION, categoryToDelete.id);
        await deleteDoc(ref);
        await archiveUploadsBySourceIdForCategory(categoryToDelete.id);
    } catch (error) {
        console.error("Error deleting category:", error);
        throw new Error("Kategori silinirken hata oluştu.");
    }
};

// Cache'ten kategori listesini al
export const getCategoriesFromCache = () => {
    const cachedCategories = JSON.parse(localStorage.getItem('categories'));
    return cachedCategories || [];
};

// Cache'i güncelle
export const updateCacheWithCategories = (categories) => {
    localStorage.setItem('categories', JSON.stringify(categories));
};

// Kategorileri getir (önce cache, yoksa Firestore)
export const getCategories = async () => {
    // const cachedCategories = getCategoriesFromCache();
    // if (cachedCategories.length > 0) {
    //     return cachedCategories.map(category => ({
    //         label: category.title.en, // İngilizce başlığı label olarak kullan
    //         value: category.id, // ID değeri olarak ayarla
    //     }));
    // } else {
    const categoriesFromFirestore = await fetchCategoriesFromFirestore();
    const categoriesList = categoriesFromFirestore.map(category => ({
        label: category.title.en,
        title: category.title,
        value: category.id,
    }));
    // updateCacheWithCategories(categoriesFromFirestore);
    return categoriesList;
    // }
};

export const updateCategoryOrder = async (orderedCategories) => {
    const batch = writeBatch(db);

    orderedCategories.forEach((category, index) => {
        const categoryRef = doc(db, CATEGORY_COLLECTION, category.id);
        batch.update(categoryRef, { order: index + 1 });
    });

    await batch.commit();
}

export const updateCategoryState = async (categoryId, newState) => {
    const ref = doc(db, CATEGORY_COLLECTION, categoryId);
    await updateDoc(ref, {
        state: newState,
    });
}

// İçeriğin bağlı olduğu kategorinin durumunu kontrol eden fonksiyon
export const isCategoryDraft = async (categoryId) => {
    const categoryRef = doc(db, CATEGORY_COLLECTION, categoryId);
    const categorySnap = await getDoc(categoryRef);

    if (categorySnap.exists()) {
        return categorySnap.data().state === "Draft"; // Kategori Draft mı?
    }
    return false; // Kategori yoksa veya başka durumdaysa false döner
};

/**
 * Kategoriye bağlı içerikleri Draft + Uncategorized yap ve kategoriyi sil
 * @param {Object} categoryToDelete Silinecek kategori objesi
 */
export const deleteCategoryAndMoveContentsToUncategorized = async (categoryToDelete) => {
    try {
        // 1. Uncategorized kategori var mı kontrol et
        const uncategorizedRef = doc(db, CATEGORY_COLLECTION, "uncategorized");
        const uncategorizedSnap = await getDoc(uncategorizedRef);

        // Yoksa oluştur
        if (!uncategorizedSnap.exists()) {
            await setDoc(uncategorizedRef, {
                title: {
                    en: "Uncategorized",
                    tr: "Kategorisiz"
                },
                summary: {
                    en: "",
                    tr: ""
                },
                url: "",
                order: 9999,
                state: "Draft",
                createdAt: serverTimestamp(),
                createdBy: null, // sistemsel olduğu için boş bırakabiliriz
                parentId: ""
            });
        }

        // 2. Bu kategoriye bağlı içerikleri getir
        const q = query(
            collection(db, CONTENT_COLLECTION),
            where("category", "==", categoryToDelete.id)
        );

        const snapshot = await getDocs(q);
        const batch = writeBatch(db);

        snapshot.forEach((docSnap) => {
            // İçeriği güncelle: Draft yap ve uncategorized kategoriye taşı
            batch.update(docSnap.ref, {
                category: "uncategorized",
                state: "Draft"
            });
        });

        // 3. Batch commit
        await batch.commit();

        // 4. Kategoriyi sil
        const categoryRef = doc(db, CATEGORY_COLLECTION, categoryToDelete.id);
        await deleteDoc(categoryRef);

        // 5. Görseli sil (varsa)
        await archiveUploadsBySourceIdForCategory(categoryToDelete.id);

        return true;
    } catch (error) {
        console.error("Error deleting category and moving contents to Uncategorized:", error);
        throw new Error("Kategori ve içerikler güncellenirken hata oluştu.");
    }
};
